export function PodDorezoReq() {
  this.PODNr = "";

  this.Marresi = "";
  this.Ora = "";
  this.Data = "";
  this.Korrieri = "";
}
